import React, { Component } from "react";
import { addUserMessage, toggleInputDisabled, addResponseMessage } from "react-chat-widget";

export default class QuickReply extends Component {
  constructor(props) {
    super(props);
    this.state = { replied: false };
    // this.sendQuickReply = this.sendQuickReply.bind(this);
  }

  sendQuickReply(reply) {
    // console.log(this.props);
    this.setState({ replied: true });
    addUserMessage(reply);
    this.props.newMessage(reply);
    // if (reply === 'ภาษาไทย') {
    //   this.getGreeting('_sandee_language', 'TH');
    // } else if (reply === 'English') {
    //   this.getGreeting('_sandee_language', 'ENG');
    // } else {
    //   this.props.newMessage(reply);
    // }
  }

  // getGreeting(key, value) {
  //   window.sessionStorage.setItem(key, value);
  //   this.props.greeting(window.sessionStorage.getItem(key), this.props.middlewareApi);
  // }

  render() {
    return (
      <div className="rcw-response-custom">
        <h6>{this.props.title}</h6>
        {this.props.buttons.map((r) => (
          <button key={r} className={"response quickreply-button"} onClick={this.sendQuickReply.bind(this, r)}>
            {r}
          </button>
        ))}
      </div>
    );
  }
}
